// tslint:disable: prefer-conditional-expression

import { IBatchInfo } from 'components/common/DataGridDevEx/DataGrid.properties';
import { objectify } from 'api/utils';
import { Payload, useFetchMutation, usePost } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';

export interface IProgram {
    module: string;
    name: string;
    key: string;
    detailsPath: string;
    requestMethod: 'GET' | 'POST';
    APIResponseKey: string;
}

const genericResponseParser = (key: string) => (response: Record<string, any>) => {
    const items = response[key];

    return {
      ...response,
      [key]: Array.isArray(items)
        ? items.map((o) => objectify(o, null))
        : items,
    };
  };

export type IRetrieveLinesPayload = Payload<{ CustomerId: number; TransactionOption?: string; EntityView?: string; FromDate?: string; ToDate?: string; TransactionType?: string}, IBatchInfo>;
export const useRetrieveLines = (program: IProgram) => {
    if (APIRoutes[program?.module][program?.name?.toLowerCase()].lines.retrieve.method === 'POST') {

        return usePost<IRetrieveLinesPayload, any>
        (APIRoutes[program?.module][program?.name?.toLowerCase()].lines.retrieve.api, null, { inline: true, responseParser: genericResponseParser(program?.APIResponseKey) });
    } else {

        return useFetchMutation<IRetrieveLinesPayload, any>
        (APIRoutes[program?.module][program?.name?.toLowerCase()].lines.retrieve.api, null, { inline: true, responseParser: genericResponseParser(program?.APIResponseKey) });
    }
};
